import classNames from 'classnames';
import { FC } from 'react';

type ColorsClass = 'text-primary' | 'text-secondary' | 'text-success' | 'text-danger' | 'text-warning' | 'text-info';

interface CustomSpinnerProps {
  opacity?: number;
  color?: ColorsClass;
  customStyle?: string;
}

export const CustomBorderSpinner: FC<CustomSpinnerProps & { size: number }> = ({
  size,
  opacity = 1,
  color = 'text-primary',
  customStyle,
}) => {
  const divStyles = {
    height: size,
    width: size,
    opacity,
  };
  return (
    <>
      <div style={divStyles} className={`spinner-border spinner-border-sm ${color} ${customStyle}`} role="status" />
      <span className="visually-hidden">Loading...</span>
    </>
  );
};

export const CustomIconSpinner: FC<CustomSpinnerProps & { size: string; className?: string }> = ({
  className,
  size,
  opacity = 1,
  color = 'text-primary',
}) => {
  const divStyles = {
    height: size,
    width: size,
    opacity,
  };
  return (
    <i style={divStyles} className={classNames(`icon icon-${size} icon-spin ${color}`, className)}>
      autorenew
    </i>
  );
};
